export default "/assets/images/problem-solved-07.c2c0a590c10b0007.webp";